export default "__VITE_ASSET__BoBjhHB0__"